import {combineReducers} from "redux"
import AuthReducer from "./AuthReducer"
import CategoriesReducer from "./CategoriesReducer"
import MainAdsReducer from "./MainAdsReducer"
import PackagesReducer from "./PackagesReducer"
import SubCategoryReducer from "./SubCategoryReducer"
import VendorsReducer from "./VendorsReducer"
import BannerReducer from "./BannerReducer"
import SocialReducer from "./SocialReducer"
import SettingReducer from "./SettingReducer"
import StoriesReducer from "./StoriesReducer"
import ReviewsReducer from "./ReviewsReducer"

export default combineReducers({
    auth: AuthReducer,
    Categories: CategoriesReducer,
    MainAdss: MainAdsReducer,
    packagee: PackagesReducer,
    sub_category: SubCategoryReducer,
    vendorss: VendorsReducer,
    bannerr: BannerReducer,
    social_media: SocialReducer,
    settings: SettingReducer,
    stories: StoriesReducer,
    revieww: ReviewsReducer
})